module.exports = __webpack_public_path__ + "static/img/code2769.f60d341.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code2769.png
// module id = 1Bsf
// module chunks = 0